import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import data from '../data/pharmaFoodGradeOils.json';
import Water from "../Images/WaterAndMinning.png";
import logo from "../Images/aman logo.png";

const ITEMS_PER_PAGE = 40;

const WaterTreatmentMining = () => {
    const [products, setProducts] = useState([]);
    const [page, setPage] = useState(1);

    useEffect(() => {
        setProducts(data);
    }, []);

    const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
    const startIndex = (page - 1) * ITEMS_PER_PAGE;
    const pagedData = products.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    return (
        <>
            {/* 🔁 Image Slider */}
            <div className="InterMedite Product-image">
                <div className="InterMedite Product-slide-track">
                    {[...Array(12)].map((_, i) => (
                        <img key={i} src={Water} alt="Water and Mining Chemical" className="slide" />
                    ))}
                </div>
            </div>

            {/* ✅ Product List */}
            <div className="search-page">
                <h2>
                    <span className="Searchcount">Water Treatment and Mining Chemicals Products List</span>
                    <span className="count">({products.length})</span>
                </h2>

                <div className="products-container">
                    <div className="results-scrollable">
                        <div className="results-grid">
                            {pagedData.map((item, index) => {
                                const productSlug = `${encodeURIComponent(item.productName)}-${encodeURIComponent(item.casNumber)}`;
                                const productLink = `${window.location.origin}/#/product/${productSlug}`;
                                return (
                                    <div key={index} className="result-card">
                                        <div className="card-header">
                                            <img src={logo} alt="Product Logo" className="card-logo" />
                                            <button
                                                className="whatsapp-button"
                                                onClick={() => {
                                                    const msg = `Hello! I'm interested in this product:\n\n*Name:* ${item.productName}\n*CAS Number:* ${item.casNumber}\n\n*View Product:*\n${productLink}`;
                                                    window.open(`https://wa.me/7405649537?text=${encodeURIComponent(msg)}`, "_blank");
                                                }}
                                            >
                                                <FaWhatsapp size={18} />
                                            </button>
                                        </div>

                                        <div className="field">
                                            <span className="label">Product Name:</span>
                                            <Link
                                                to={`/product/${productSlug}`}
                                                state={{ backTo: window.location.pathname }}
                                                className="value link"
                                            >
                                                {item.productName}
                                            </Link>
                                        </div>

                                        <div className="field">
                                            <span className="label">CAS Number:</span>
                                            <span className="value">{item.casNumber}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* 🔽 Pagination */}
                <div className="pagination">
                    <button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>‹ Prev</button>
                    {(() => {
                        const maxVisible = 7;
                        let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
                        let endPage = startPage + maxVisible - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - maxVisible + 1);
                        }

                        const pages = [];
                        for (let p = startPage; p <= endPage; p++) pages.push(p);

                        return (
                            <>
                                {startPage > 1 && (
                                    <>
                                        <button onClick={() => handlePageChange(1)}>1</button>
                                        {startPage > 2 && <span className="dots">...</span>}
                                    </>
                                )}
                                {pages.map(p => (
                                    <button
                                        key={p}
                                        onClick={() => handlePageChange(p)}
                                        className={`page-number ${p === page ? 'active' : ''}`}
                                    >
                                        {p}
                                    </button>
                                ))}
                                {endPage < totalPages && (
                                    <>
                                        {endPage < totalPages - 1 && <span className="dots">...</span>}
                                        <button onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                                    </>
                                )}
                            </>
                        );
                    })()}
                    <button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>Next ›</button>
                </div>
            </div>
        </>
    );
};

export default WaterTreatmentMining;
